import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollAPDFileExportDetail  {
    _originalTypeClassName = "zERP.BO.PayrollAPDFileExportDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollAPDFileExportDetail.translate = translateService;
}
this.Id = null;
this.SICPackageType = null;
this.DateCreated = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
SICPackageType:any;
DateCreated:any;
FileData:any;
PayrollAPDFileExport:any;
PayrollIntegration:any;
static setFileData = ($this, value) => {
var oldValue = $this.FileData;
$this.FileData = value;
if (value != null) {
}
}
static setPayrollAPDFileExport = ($this, value) => {
var oldValue = $this.PayrollAPDFileExport;
$this.PayrollAPDFileExport = value;
if (value != null) {
if (oldValue != null) {
Domain.PayrollAPDFileExport.removeDetails(oldValue, $this);
}
Domain.PayrollAPDFileExport.addDetails(value, $this);
}
}
static setPayrollIntegration = ($this, value) => {
var oldValue = $this.PayrollIntegration;
$this.PayrollIntegration = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}